import { useMemo } from 'react'
import { useControlStore } from '@editorStores'
import useIfcFiles from './useIfcFiles'

/**
 * Resolve the guid of the IFC/GLB file the storey controls and IFC element-type selection act on.
 * Returns `null` for an empty file list, the store's `activeIfcFileGuid` when it matches a loaded
 * file, and otherwise falls back to the last file.
 */
const useActiveIfcFileGuid = (): string | null => {
  const activeIfcFileGuid = useControlStore(state => state.activeIfcFileGuid)
  const glbFiles = useIfcFiles()

  return useMemo(() => {
    if (glbFiles.length === 0) return null
    // Only trust the stored guid if it still refers to a currently loaded file; a stale value
    // (file removed/replaced, or never set) falls back to the last file instead.
    const active =
      activeIfcFileGuid != null
        ? glbFiles.find((file: FileItem) => file.guid === activeIfcFileGuid)
        : null
    return (active ?? glbFiles[glbFiles.length - 1]).guid ?? null
  }, [glbFiles, activeIfcFileGuid])
}

export default useActiveIfcFileGuid
